module.exports = __webpack_public_path__ + "static/1-51fc4d4289fc701afe59bc7e8457d597.jpg";